import { Component, EventEmitter, Inject, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { TEMPLATE_PREFIX } from '../../environments/locale-config';
import { IModalService, MODAL_SERVICE_TOKEN } from '../../services/IModalService';
import { UploadFileInfoModel } from '../text-editor-file-upload-modal/upload-file-info.model';

@Component({
    selector: 'kh-upload-file-modals-holder',
    styleUrls: ['./upload-file-modals-holder.component.less'],
    templateUrl: TEMPLATE_PREFIX + 'upload-file-modals-holder.component.html',
    standalone: false
})
export class UploadFileModalsHolderComponent implements OnInit {
  @ViewChild('uploadFileModal', { static: false }) public uploadFileModal: TemplateRef<void> | undefined;
  @ViewChild('chooseSourceModal', { static: false }) public chooseSourceModal: TemplateRef<void> | undefined;
  public uploadFileModalRef?: BsModalRef;
  public chooseSourceModalRef?: BsModalRef;
  @Input() public imagePath = '';
  @Input() public allowFolders = true;

  @Output() public hideModals = new EventEmitter<UploadFileInfoModel | null>();

  private _image: UploadFileInfoModel = this.getDefModel();

  public constructor(@Inject(MODAL_SERVICE_TOKEN) private modalService: IModalService) {
  }

  public get sourceImage(): UploadFileInfoModel {
    return this._image;
  }

  @Input()
  public set sourceImage(image: UploadFileInfoModel | null) {
    this._image = image ?? this.getDefModel();
  }

  public ngOnInit(): void {
    setTimeout(() => {
      this.uploadFileModalRef = this.modalService.displayModal(this.uploadFileModal, {}, 'sm-plus', 'static', 'static');
    });
  }

  public linkUpdated(linkEvent: string): void {
    this._image = {
      ...this._image,
      src: linkEvent
    };
    this.chooseSourceModalRef?.hide();
  }

  public formClosed(value: UploadFileInfoModel | null): void {
    this.uploadFileModalRef?.hide();
    this.hideModals.emit(value);
  }

  public formOpened() {
    this.chooseSourceModalRef = this.modalService.displayModal(this.chooseSourceModal, {}, 'lg', 'static', 'static');
  }

  private getDefModel(): UploadFileInfoModel {
    return {
      alt: '',
      constrain: true,
      height: '',
      src: '',
      width: ''
    };
  }
}
